import React, { Component } from 'react';
import LeftLink from '../leftlink/leftlink.jsx';
import AuthNavbar from '../navigation/authnavigation.jsx';
import SuspendCard from './suspendcard.jsx';

class BlockCards extends Component {
    render() {
        return (
            <div>
                <div className="row" >
                    <div className="col-sm-12 p-0 m-0">
                        <AuthNavbar />
                    </div>
                    <div className="container" style={{  }}>
                        <div className="row">
                            {/* <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                                <LeftLink />
                            </div> */}

                            <div className="col-sm-12" style={{ padding: "0px 30px" }}>
                                <div className="header-style" style={{ padding: "5px 20px 0px 15px" }}>
                                    <h4 className='logmainheading mainheading'>
                                        Lock / Unlock Card
                                    </h4>
                                    <p>
                                        Choose the card you want to Lock / Unlock from the dropdown list.
                                    </p>
                                </div>
                                <div className="col-md-12" style={{  minHeight: "476px" }}>
                                    <SuspendCard />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BlockCards;




// WEBPACK FOOTER //
// ./src/components/additionalservices/blockcards.jsx